import type { ComponentPropsWithoutRef } from "react"
import Link from "next/link"
import cn from "classnames"

import { Icon } from "~/components/primitives/icon"
import type { CtaLink as CtaLinkType } from "~/types/cms"
import type { Theme } from "~/types/general"

import s from "./SecondaryButton.module.scss"

type SecondaryButtonProps = {
  cta: CtaLinkType
  className?: string
  theme?: Theme
} & ComponentPropsWithoutRef<"a">

export const SecondaryButton = ({
  cta,
  className = "",
  theme = "light",
  ...rest
}: SecondaryButtonProps) => {
  const { url, label } = cta

  if (!url) {
    return null
  }

  return (
    <Link
      href={url}
      className={cn(s.secondaryButton, s[theme], className)}
      {...rest}
    >
      <span className={s.label}>{label}</span>
      <span className={s.iconContainer} aria-hidden="true">
        <Icon id="link-arrow" className={s.icon} />
      </span>
    </Link>
  )
}
